module.exports = __webpack_public_path__ + "img/Add Patient - Green.5766de7d.png";